import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetContactDeliverabilityStatuses as GetContactDeliverabilityStatusesQuery,
    GetContactDeliverabilityStatusesVariables,
    EmailDeliverabilityFragment,
    SmsDeliverabilityFragment,
} from 'nutshell-graphql-types';

import GET_CONTACT_DELIVERABILITY_STATUSES from '../queries/get-contact-deliverability-statuses.graphql';

export const useGetContactDeliverabilityStatuses = (
    contactId: string
): {
    emailDeliverabilityStatus: EmailDeliverabilityFragment | null | undefined;
    smsDeliverabilityStatus: SmsDeliverabilityFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetContactDeliverabilityStatusesQuery,
        GetContactDeliverabilityStatusesVariables
    >(GET_CONTACT_DELIVERABILITY_STATUSES, {
        variables: {
            contactId,
        },
    });

    const contact = data?.contact;
    const emailDeliverabilityStatus = contact?.emailAddresses?.primary?.deliverabilityStatus;
    const smsDeliverabilityStatus = contact?.phones?.primary?.deliverabilityStatus;

    return {
        emailDeliverabilityStatus,
        smsDeliverabilityStatus,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
